/**
 * Importando o codeblock
 */
import codeBlock from './code-block/code-block';

/**
 * Importando os formulários
 */
import formInput from './forms/form-input';
import formSelect from './forms/form-select';

/**
 * Importando o loader
 */
import loadingScreen from './loading-screen/loading-screen';

/**
 * Importando o svg-icon
 */
import svgIcon from './svg/svg-icon';
import svgSprite from './svg/svg-sprite';

/**
 * Importando o tooltip
 */
import tooltip from "./tooltip/tooltip";

/**
 * Importando o tag
 */
import tag from "./tag/tag";

/**
 * Importando o title
 */
import title from "./title/title";


/**
 * Importando o input-file
 */
import inputFile from "./input-file/input-file";

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
    install (Vue) {
        Vue.component('code-block', codeBlock);
        Vue.component('form-input', formInput);
        Vue.component('loading-screen', loadingScreen);
        Vue.component('loading-screen', loadingScreen);
        Vue.component('svg-icon', svgIcon);
        Vue.component('svg-sprite', svgSprite);
        Vue.component('tooltip', tooltip);
        Vue.component('title-header', title);
        Vue.component('input-file', inputFile);
    }
}

export default GlobalComponents
